import PropTypes from "prop-types";
import { useWatch } from "react-hook-form";
function CondtionalField({
  name,
  value,
  children
}) {
  const currentValue = useWatch({
    name
  });
  return currentValue === value ? children : null;
}
CondtionalField.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  value: PropTypes.any
};
export {
  CondtionalField as default
};
